/* Imp Note to Reader */
/* The `ReportSecondaryStatusPill` component is the first one where we have a Figma for component design, typography etc */
/* All components created before were generated via V0 or Claude since we were in a pre-mvp stage */
/* This is why this component (and ones after this) will have a separate CSS file  */
/* Additionally, in some cases, certain values may be hardcoded in the CSS instead of relying on globals  */
/* and tailwind.config.js. This is intentional and done to avoid dealing with global conflicts */
/* and keeping the surface area of changes limited. While this is not ideal, the speed at which we need to move till */
/*  Sep/Oct 2025 justifies this decision. */


import React from 'react';
import styles from './ReportSecondaryStatusPill.module.css';
import { ReportStatusPillVariant } from '../../../constants/reports'

export interface ReportSecondaryStatusPillProps {
  variant: ReportStatusPillVariant;
  text: string;
  className?: string;
}

const ReportSecondaryStatusPill: React.FC<ReportSecondaryStatusPillProps> = ({
  variant,
  text,
  className = '',
}) => {
  const pillClassName = `${styles.pill} ${styles[variant]} ${className}`.trim();

  return (
    <span className={pillClassName}>
      {text}
    </span>
  );
};

export default ReportSecondaryStatusPill;